<template>
  <div class="contents wrap" ref="appMain">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    },
  },
}
</script>
<style lang="scss" scoped>
// .wrap {
//   height: 500px;
// }
.contents {
  margin: 40px auto 60px auto;
}
</style>